module.exports = __webpack_public_path__ + "img/rebates.7de9ec47.svg";